import React from 'react'
import styled from '@emotion/styled'
import { colors, typography, mediaQueries as mq } from 'src/styles'
import Link from 'src/components/Link'
import DownloadIcon from 'src/svg/icon-download.svg'
import PropTypes from 'prop-types'

const DownloadLink = styled(Link)`
  display: flex;
  flex-direction: row;
  align-items: center;
  ${ ({ mainColor }) => `
    color: ${colors[mainColor]};
    &:hover {
     color: ${colors[`${mainColor}Darken`] };
    }
  `}
`
const DownloadLinkIcon = styled(DownloadIcon)`
  flex-shrink: 0;
  height: 30px;
  width: 30px;

  ${ mq.mediumAndUp } {
    height: 65px;
    width: 65px;
  }
`

const DownloadLinkLabel = styled.div`
  ${ typography.h4 }
  line-height: ${typography.leadingTight};
  margin-left: 15px;
  font-size: ${typography.fontSizeMedium};

  ${ mq.mediumAndUp } {
    margin-left: 30px;
    font-size: ${typography.fontSizeExtraLarge2}
  }

  ${ ({ useResourceStyles }) => useResourceStyles && `
    color: ${colors.textColor};
  `}
`

export default function DownloadButton ({ buttonLabel, buttonUrl, pageColors, useResourceStyles = false }) {
  const { mainColor } = pageColors;

  return (
    <DownloadLink mainColor={mainColor} external={true} to={buttonUrl}>
      <DownloadLinkIcon />
      <DownloadLinkLabel useResourceStyles={useResourceStyles}>{buttonLabel}</DownloadLinkLabel>
    </DownloadLink>
  )
}

DownloadButton.propTypes = {
  buttonLabel: PropTypes.string,
  buttonUrl: PropTypes.string,
  pageColors: PropTypes.object,
  useResourceStyles: PropTypes.bool
}

